<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16 27.333c6.26 0 11.334-5.074 11.334-11.334C27.334 9.74 22.26 4.666 16 4.666c-6.259 0-11.333 5.074-11.333 11.333 0 6.26 5.074 11.334 11.333 11.334zm0 2c7.364 0 13.334-5.97 13.334-13.334 0-7.363-5.97-13.333-13.334-13.333-7.363 0-13.333 5.97-13.333 13.333 0 7.364 5.97 13.334 13.333 13.334z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsRadioButtonOutline'
}
</script>
